module.exports = {
  PRG: "PRG",
  ELD: "ELD",
  IMP: "IMP",
  DIS: "DIS",
  HEA: "HEA",
};
